var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75736 1.75736C0 3.51472 0 6.34315 0 12V16C0 21.6569 0 24.4853 1.75736 26.2426C3.51472 28 6.34315 28 12 28H24C29.6569 28 32.4853 28 34.2426 26.2426C36 24.4853 36 21.6569 36 16V12C36 6.34315 36 3.51472 34.2426 1.75736C32.4853 0 29.6569 0 24 0H12C6.34315 0 3.51472 0 1.75736 1.75736ZM7.1094 6.3359C6.19034 5.72319 4.9486 5.97154 4.3359 6.8906C3.72319 7.80966 3.97154 9.0514 4.8906 9.6641L15.7812 16.9245C17.1248 17.8202 18.8752 17.8202 20.2188 16.9245L31.1094 9.6641C32.0285 9.0514 32.2768 7.80966 31.6641 6.8906C31.0514 5.97154 29.8097 5.72319 28.8906 6.3359L18 13.5963L7.1094 6.3359Z",
    fill: "#FF0050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingMail);
export default __webpack_public_path__ + "static/media/SettingMail.4681545fe814591361ad45850a8e33ec.svg";
export { ForwardRef as ReactComponent };